"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const validations_1 = require("../../../utils/validations");
const StreamPartID_1 = require("../../../utils/StreamPartID");
class ProxyConnectionRequest extends ControlMessage_1.default {
    constructor({ version = ControlMessage_1.default.LATEST_VERSION, requestId, senderId, streamId, streamPartition, direction, userId }) {
        super(version, ControlMessage_1.default.TYPES.ProxyConnectionRequest, requestId);
        (0, validations_1.validateIsNotNullOrUndefined)('senderId', senderId);
        this.senderId = senderId;
        (0, validations_1.validateIsString)('streamId', streamId);
        this.streamId = streamId;
        (0, validations_1.validateIsInteger)('streamPartition', streamPartition);
        this.streamPartition = streamPartition;
        (0, validations_1.validateIsDirection)('direction', direction);
        this.direction = direction;
        (0, validations_1.validateIsString)('userId', userId);
        this.userId = userId;
    }
    getStreamPartID() {
        return (0, StreamPartID_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
}
exports.default = ProxyConnectionRequest;
//# sourceMappingURL=ProxyConnectionRequest.js.map